import { render, staticRenderFns } from "./user-tag.vue?vue&type=template&id=26097956&scoped=true&"
import script from "./user-tag.vue?vue&type=script&lang=js&"
export * from "./user-tag.vue?vue&type=script&lang=js&"
import style0 from "./user-tag.vue?vue&type=style&index=0&id=26097956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26097956",
  null
  
)

export default component.exports